export { DialogRoot as Dialog } from 'reka-ui';
export { default as DialogContent } from './DialogContent.vue';
export { default as DialogHeader } from './DialogHeader.vue';
export { default as DialogFooter } from './DialogFooter.vue';
export { default as DialogTitle } from './DialogTitle.vue';
export { default as DialogDescription } from './DialogDescription.vue';
export { default as DialogOverlay } from './DialogOverlay.vue';
export { DialogPortal, DialogTrigger, DialogClose } from 'reka-ui';
